import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';
import {FormGroup, Grid} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {greyishBlue500} from "../../../../assets/jss/main";
import {WMSContext} from "../../context/WMSContext";

DrawerContent.propTypes = {
    searchString: PropTypes.string.isRequired,
    contents: PropTypes.objectOf(PropTypes.shape({
        name: PropTypes.string,
        count: PropTypes.number,
        logo: PropTypes.string,
        selected: PropTypes.bool
    })).isRequired,
    handleSelectContent: PropTypes.func.isRequired,
    isModel: PropTypes.bool.isRequired,
    tradKey: PropTypes.string.isRequired,
};

const thumbnailStyle = {
    width: "40px",
    height: "40px",
    margin: "auto 0",
    borderRadius: "8px"
}

const titleStyle = {
    height: "fit-content",
    margin: "auto 0",
    fontSize: "14px",
    fontWeight: 600
}

const subtitleStyle = {
    height: "fit-content",
    margin: "auto 0",
    fontSize: "12px",
    fontWeight: 400,
    color: greyishBlue500
}

function DrawerContent({searchString, contents, handleSelectContent, isModel, tradKey}) {
    const {isMobile} = useContext(WMSContext)

    const [formattedContents, setFormattedContents] = useState([])
    const [searchedContents, setSearchedContents] = useState([]) // --> Use this to update the displayed list

    useEffect(() => {
        if (searchString.length === 0) {
            setSearchedContents(formattedContents)
        } else {
            let tempData = []
            formattedContents.map(content => {
                if (typeof content.name === "string" && content.name.toLowerCase().includes(searchString.toLowerCase())) {
                    tempData.push(content)
                }
            })
            setSearchedContents(tempData)
        }
    }, [formattedContents, searchString]);


    useEffect(() => {
        const dataKeys = Object.keys(contents)
        let tempData = []
        dataKeys.map((k) => {
            if (k !== "all") {
                tempData.push(contents[k])
            }
        })

        setFormattedContents(tempData)
    }, [contents]);

    return (
        <Grid
            container
            direction={"column"}
            sx={{paddingX: isMobile ? '16px' : '0'}}
        >
            <FormGroup sx={{marginTop: "20px"}}>
                {contents && searchedContents && searchedContents.map((content) => {
                    if (!isModel && content.count === 0) {
                        return null
                    }
                    return (
                        <div onClick={() => handleSelectContent(content)} style={{marginBottom: "24px"}}>
                            <Grid container direction={'row'} flexWrap={'nowrap'}>
                                <Grid container gap={"8px"} direction={"row"} flexWrap={'nowrap'}>
                                    {content.logo && (
                                        <img style={thumbnailStyle} src={content.logo} alt={`${content.name} icon`}/>
                                    )}
                                    <Grid container direction={"column"}>
                                        <span style={titleStyle}>{content.name}</span>
                                        {content.count >= 0 && (
                                            <span style={subtitleStyle}>
                                            {content.count} <FormattedMessage id={`wms.newPickingMission.${tradKey}Drawer.articles`}/>
                                        </span>
                                        )}
                                    </Grid>
                                </Grid>
                                <Checkbox checked={content.selected}/>
                            </Grid>
                        </div>
                    )
                })}
            </FormGroup>
        </Grid>
    );
}

export default DrawerContent;